import React from 'react';
import './App.css';
import PrivacyPolicy from './components/privacypolicy';
function App() {
    return (
        <div className="App">
           < PrivacyPolicy />
        </div>
    );
}

export default App;
